import moment from "moment";

const DateFormatter = ({ date, ago = false }) => {
  if (ago) {
    return <>{moment(new Date(date)).fromNow()}</>
  }

  const formattedDate = new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });

  return <>{formattedDate}</>
}

export default DateFormatter;